import React from 'react';
import _ from 'lodash';
import { Col, Row, FieldWrapper } from '@mlc/web-ui-toolkit';
import { AccountFilterElements } from './AccountFilterElements';
import AccountTypeFilter from './AccountTypeFilter/AccountTypeFilter';
import AgeFilter from './AgeFilter/AgeFilter';
import PostcodeFilter from './PostcodeFilter/PostcodeFilter';
import * as Styled from '../styled';
import { FilterWrapper } from './styled';
import GroupFragment from '../../../containers/GroupFragment/GroupFragment';

interface Props {
	accountFilters: {
		accountType: string[];
		ageMin: string;
		ageMax: string;
		postcode: string;
		showLinkedAccountsOnly: boolean;
		includeClosedAccounts: boolean;
	};
	formikProps: any;
}

const AccountFilters = (props: Props) => {
	const { handleChange } = props.formikProps;
	const {
		accountType,
		ageMin,
		ageMax,
		postcode,
		showLinkedAccountsOnly,
		includeClosedAccounts,
	} = props.accountFilters;
	return (
		<div data-id={AccountFilterElements.accountFiltersId}>
			<Styled.SectionHeadingRow>
				<Col>
					<Styled.SectionHeading el="h5">Accounts</Styled.SectionHeading>
				</Col>
			</Styled.SectionHeadingRow>
			<Row>
				<Col md="5" sm="12">
					<Row>
						<Col md="12" sm="12">
							<FieldWrapper label="Account type">
								<AccountTypeFilter accountType={accountType} />
							</FieldWrapper>
						</Col>
					</Row>
					<Row>
						<Col md="12" sm="12">
							<FilterWrapper>
								<FieldWrapper label="Closed and Linked">
									<GroupFragment>
										<Styled.FilterCheckbox
											name="includeClosedAccounts"
											label="Include closed accounts"
											value={includeClosedAccounts}
											checked={includeClosedAccounts}
											onChange={handleChange}
											data-id={
												AccountFilterElements.closedAccountCheckboxFilterId
											}
										/>

										<Styled.FilterCheckbox
											name="showLinkedAccountsOnly"
											label="Show linked accounts only"
											value={showLinkedAccountsOnly}
											checked={showLinkedAccountsOnly}
											data-id={
												AccountFilterElements.linkedAccountCheckboxFilterId
											}
											onChange={handleChange}
										/>
									</GroupFragment>
								</FieldWrapper>
							</FilterWrapper>
						</Col>
					</Row>
				</Col>
				<Col md="5" sm="12" mdOffset="2">
					<Row>
						<AgeFilter
							ageMax={ageMax}
							ageMin={ageMin}
							formikProps={props.formikProps}
						/>
					</Row>
					<Row>
						<PostcodeFilter
							postcode={postcode}
							formikProps={props.formikProps}
						/>
					</Row>
				</Col>
			</Row>
		</div>
	);
};

export default AccountFilters;
